import { render, staticRenderFns } from "./BlackBaudOne.vue?vue&type=template&id=4fc4146d&scoped=true"
import script from "./BlackBaudOne.vue?vue&type=script&lang=js"
export * from "./BlackBaudOne.vue?vue&type=script&lang=js"
import style0 from "./BlackBaudOne.vue?vue&type=style&index=0&id=4fc4146d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc4146d",
  null
  
)

export default component.exports